const redirects = {
  ...(require('../assets/redirects')),
  ...(require('../assets/product-redirects')),
  ...(require('../assets/product-category-redirects')),
  ...(require('../assets/product-climbcombinations-redirects'))
};

function redirect(res, url) {
  res.writeHead(301, { Location: url });
  res.end();
}

export default (req, res, next) => {
  let newUrl = false;
  if (/\/$/.exec(req.url)) {
    newUrl = req.url.replace(/\/$/, '');
  }

  if (req.url.startsWith('//')) {
    newUrl = req.url.replace(/^\/\//, '/');
  }

  if (/^\/productlijnen\//.exec(req.url)) {
    newUrl = req.url.replace(/^\/productlijnen\/(.*)/, `/productlijnen-en-brochures/$1`)
  }

  if (/^\/sport-en-beweging\//.exec(req.url)) {
    newUrl = req.url.replace(/^\/sport-en-beweging\/(.*)/, `/sporttoestellen/$1`)
  }

  if (/^\/sporttoestellen\/beweegtuin\//.exec(req.url)) {
    newUrl = req.url.replace(/^\/sporttoestellen\/(.*)/, `/parkinrichting/$1`)
  }

  if (/^\/speeltoestellen\/interactief\//.exec(req.url)) {
    newUrl = req.url.replace(/^\/speeltoestellen\/(.*)/, `/sporttoestellen/$1`)
  }

  if (/^\/speeltoestellen\/klimtoestellen\/ruimtenetten\//.exec(req.url)) {
    newUrl = req.url.replace(/^\/speeltoestellen\/klimtoestellen\/ruimtenetten\/(.*)/, `/speeltoestellen/klimtoestellen/klimpiramides/$1`)
  }

  console.error([
    newUrl,
    req.url
  ]);

  if (redirects[newUrl || req.url]) {
    newUrl = redirects[newUrl || req.url];
  }

  const hostname = req.headers.host || '';
  if (hostname.includes('sportprojecten.com')) {
    newUrl = `${process.env.BASE_URL}/sporttoestellen`;
  }
  else if (
    hostname.includes('igym-outdoor.com') ||
    hostname.includes('igymoutdoor.com')
  ) {
    newUrl = `${process.env.BASE_URL}/sporttoestellen/igym-outdoor-fitness`;
  }

  if (hostname.startsWith('www.')) {
    newUrl = `${process.env.BASE_URL}${req.url}`;
  }

  if (newUrl) {
    if (newUrl.startsWith('http://')) {
      newUrl = `https://${newUrl.slice(7)}`
    }

    redirect(res, newUrl);
  } else {
    next();
  }
}
